













































import { Component, Prop, Mixins } from "vue-property-decorator";
import { Choice } from "@/types";
import { Staff, DefaultStaff } from "#/model/staff";
import { covid19VaccineStatuses } from "#/model/patient";
import GroupSelector from "@/components/patient/info/GroupSelector.vue";
import RulesMixin from "#/mixins/rulesMixin";
import UtilMixin from "@/mixins/utilMixin";

@Component({
  components: {
    GroupSelector
  }
})

/** グループ編集 */
export default class GroupEditor extends Mixins(UtilMixin, RulesMixin) {
  /** Prop */

  /** 職員 */
  @Prop({ default: () => DefaultStaff() }) staff!: Staff;

  /** グループマスタ */
  @Prop({ default: () => [] }) groupItems!: Choice[];

  /** 変数 */

  /** コロナワクチン接種状況選択肢 */
  private covid19VaccineStatuses = covid19VaccineStatuses;
}
